// Optional program binding for chat surfaces. WorkroomPage provides it so
// deep chat components (the artifact drawer) can offer program-level actions
// ("Save to program documents") without threading props through ChatView.
// Outside the Workroom the context is null and those affordances stay hidden.
import { createContext, useContext } from 'react';
const WorkroomProgramContext = /*#__PURE__*/ createContext(null);
export const WorkroomProgramProvider = WorkroomProgramContext.Provider;
/** Null outside the Workroom — callers branch on presence. */ export function useWorkroomProgram() {
    return useContext(WorkroomProgramContext);
}
